var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentful-container"},[(_vm.document && _vm.document.json)?_c('contentful-rich-text',{attrs:{"document":_vm.document.json,"nodeRenderers":_vm.renderNodes(),"markRenderers":_vm.renderMarks()}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }